





















































import _ from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import qs from 'qs';
import { Route } from 'vue-router';
import Login from '@/main/pages/Login.vue';
import SessionOver from '@/main/pages/SessionOver.vue';
import { SSOState } from '@/main/store/authorization/state';
import { EventBus } from '@/main/eventBus';
import { CRUMBS, IS_AUTH, GET_TEXT } from '@/main/store/getterTypes';
import { NavigationMenu } from '@/main/menu';
import DmsBreadcrumbItem from '@/main/components/dms/form/BreadcrumbItem.vue';
import { ShortcutMixin } from '@/main/mixins/shortcut';
import { Zakazka } from '@/modules/servis/zakazka';
import { NdSklad } from '@/modules/sklad/ndSklad';
import CreateModal from '@/modules/servis/zakazka/components/CreateModal.vue';
import { PageMode, PageModeUtils } from '@/main/utils/pageMode';
import { types } from '@/main/store/external/types';
import CustomerFeedback from '@/main/pages/CustomerFeedback.vue';
import mixins from 'vue-typed-mixins';

import { apiProvider } from './api';
import { httpRequest } from '#services/httpRequest';

import { listName } from '../store/listEditTypes';
import { openList } from '../router/routerPath';
import { LANGUAGE_CODE, LANGUAGE_ID, LOCALSTORAGE_STATE_KEY } from '../store/constants';
import {
	AUTH_AUTOLOGIN, AUTH_LOGOUT, AUTH_USER, ERROR,
	LOAD_STATE, PAGE_MGR_CLEAR, SAVE_STATE, SSO_SIGNOUT, SSO_STATE_UPDATE,
} from '../store/actionTypes';
import { RouteType } from '../menu/constants';
import { ExternalCrumb } from '../store/@types/external.d';
import { TENANT_NAME } from '../store/authorization/constants';
import { OpenerMixin } from '../mixins/opener';
import { AutoLogoutMixin } from '../mixins/autoLogout';
import { ActivityTrackerMixin } from '../mixins/activityTracker';
import { resourcesService } from '@/main/services';

interface MainCrumbHandler {
	url?: string;
	type: RouteType;
	name: string;
}

const BREADCRUMB_CACHE_KEY = 'DMS_BREADCRUMB_CACHE';
export default mixins(ShortcutMixin, OpenerMixin, AutoLogoutMixin, ActivityTrackerMixin).extend({
	name: 'DmsMain',
	components: {
		CreateModal,
		NavigationMenu,
		Login,
		SessionOver,
		DmsBreadcrumbItem,		
		CustomerFeedback,
	},
	data() {
		return {
			mode: '',
			prepared: false,
			dmsVersion: process.env.VUE_APP_VERSION as string,
			dmsAppName: process.env.VUE_APP_NAME as string,
			SSOState,
			loadingInstance: null,
			component: '' as string,
			workShop: [] as any[],
			workShopId: null as number | null,
			isWorkshopVisible: true as boolean,
			fallbackBreadcrumbs: [] as MainCrumbHandler[],
		};
	},

	computed: {
		...mapGetters({
			isAuth: IS_AUTH,
			crumbs: CRUMBS,
			currentPage: 'pageManager/getCurrentPage',
			getTextFrom: GET_TEXT,
		}),

		computedBreadcrumbs(): MainCrumbHandler[] {
			const { crumbs }: { crumbs: ExternalCrumb[] } = this.$store.state.external;
			if (crumbs.length > 0) {
				return crumbs.map((rec) => ({
					url: rec.url,
					type: RouteType.external,
					name: `${rec.i18nKey} - ${this.getTextFrom(`mode${PageModeUtils.getModeByDefaultView(_.last(rec.url.split('/')))}`)}`,
				}));
			}

			const internalBreadcrumbs = this.getInternalBreadcrumbs();
			if (internalBreadcrumbs.length > 1) {
				return internalBreadcrumbs;
			}

			if (internalBreadcrumbs.length === 1 && this.fallbackBreadcrumbs.length > 1) {
				const currentCrumb = internalBreadcrumbs[0];
				const lastFallbackCrumb = this.fallbackBreadcrumbs[this.fallbackBreadcrumbs.length - 1];

				if (lastFallbackCrumb && lastFallbackCrumb.name === currentCrumb.name) {
					return this.fallbackBreadcrumbs;
				}
			}

			return internalBreadcrumbs;
		},

		loggedUserFullName(): string {
			this.getWorkShop();
			return this.loggedUser ? `${this.loggedUser.Jmeno?.charAt(0).toUpperCase()}${this.loggedUser.Prijmeni?.charAt(0).toUpperCase()}` : '';
		},

		loading(): boolean {
			if (!this.currentPage) return false;
			const modul = this.currentPage.storeModule;
			return !!modul && !!this.$store.state.pages[modul] && this.$store.getters[`pages/${modul}/loading`];
		},

		dms3Hash(): string {
			return this.$store.state.authorization.dms3Hash;
		},

		tenantName(): string {
			// TODO: tenant should be saved in store and hydrated
			return window.localStorage.getItem(TENANT_NAME) || '';
		},

		whitelabelBrand(): string | null {
			return window.localStorage.getItem('WHITELABEL');
		},		
		
	},

	watch: {
		crumbs: {
			deep: true,
			handler() {
				this.updateBreadcrumbCache();
				this.restoreBreadcrumbsFromCache();
				this.refreshPageTitle();
			},
		},
		'$route.path'() {
			this.restoreBreadcrumbsFromCache();
		},
	},

	created() {
		this.initialiseStore();
		this.checkIdentityInitialization();
		this.loadState();		
		this.restoreBreadcrumbsFromCache();

		/**
		 * TODO: zjistit jazyk resource a dosadit správně
		 * cs - česky, sk - slovensky, en - english
		 * {@link https://forum.vuejs.org/t/settings-lang-sv-to-the-html-tag/7047 zdroj}
		 */
		const html = document.documentElement;
		html.setAttribute('lang', 'cs');
	},

	mounted() {
		EventBus.$on('Mode', (mode: PageMode) => {
			this.mode = mode;
		});

		if (process.env.VUE_APP_USE_MPOV_EXTERNAL === 'true') { // TODO: this should be removed later
			const queryParams = qs.parse(window.location.search, {
				ignoreQueryPrefix: true,
			});

			if (!_.isUndefined(queryParams.opener)) {
				const {
					opener: openerString,
					openerHost,
					prop,
					openerAction: action,
					...extraParams
				} = queryParams;

				this.$store.commit(`external/${types.mutations.SET_OPENER}`, {
					opener: openerString, host: openerHost, prop, action, extraParams,
				});
			}

			this.$router.beforeEach(this.externalFrameChecker);
		}	
	},

	async beforeMount() {
		const queryParams = qs.parse(window.location.search, {
			ignoreQueryPrefix: true,
		});

		/** To access other pages than Main.vue need to enter below url
		* websiteurl/public/CustomerFeedback or websiteurl/public/EmailVerification
		*/
		const { path } = this.$route;
		if (path.includes('/public/')) {
			this.component = path.split('/')[path.split('/').length - 1];
		}

		if (queryParams.ssoRedirect) {
			this.setSSOState(SSOState.Auth);
		}

		document.title = this.dmsAppName;
		if (this.isAuth) {
			const loading = this.$loading({ fullscreen: true });
			await this.authUser();
			loading.close();
		}

		this.prepared = true;
	},

	methods: {
		...mapMutations({
			initialiseStore: types.actions.INITIALISE_STORE,
			setSSOState: SSO_STATE_UPDATE,
			replaceExternalCrumbs: `external/${types.mutations.REPLACE_EXTERNAL_CRUMBS}`,
			// TODO: ZJ
			// setZakazkaCheckboxFilters: `${Servis.name}/${Zakazka.store.types.mutations.SET_ZAKAZKA_CHECKBOX_FILTERS}`,
		}),

		...mapActions({
			clearPages: `pageManager/${PAGE_MGR_CLEAR}`,
			logoutUser: AUTH_LOGOUT,
			SSOLogout: SSO_SIGNOUT,
			authUser: AUTH_USER,
			loadStoreState: LOAD_STATE,
			saveStoreState: SAVE_STATE,
			error: ERROR,
		}),

		async getWorkShop() {
			const { data } = await apiProvider.GetWorkShops();			
			this.workShop = data;
			this.workShopId = this.loggedUser.PracovnikData.ProvozovnaId;
			window.sessionStorage.setItem('workshopId', String(this.workShopId));					
		},

		async onWorkShopChange(workshopId: string) {        
            window.sessionStorage.setItem('workshopId', workshopId);
            await this.getDealerData(workshopId);
            const external = document.getElementById('wmsIframe') as HTMLIFrameElement;
            external.contentWindow!.location.reload(true);
		},
		async getDealerData(workshopId: string) {
			const workShopId = JSON.parse(workshopId);
			var dealerResult = await apiProvider.GetDealerDetails();
			const DealerDetails = {
				saReceptionSlot: dealerResult.data[0].SA_RECEPTION_SLOT,
				deliverySlot: dealerResult.data[0].DELIVERY_SLOT,
				plannerStartTime: dealerResult.data[0].PLANNER_START_TIME,
				plannerEndTime: dealerResult.data[0].PLANNER_END_TIME,
				languageId: dealerResult.data[0].LANGUAGE_ID,

			};
			localStorage.setItem("DealerDetails", JSON.stringify(DealerDetails));
			if (!_.isNull(workShopId)) {
                const params = {
                    workshopId: workShopId,
                };
                const dealerLocationResult = await apiProvider.DealerWorkShopDetails(params);
                localStorage.setItem('DealerWorkShopDetails', JSON.stringify(dealerLocationResult?.data));
            }
		},
		// if we come from identity app, we are getting special query and already have cookies
		async checkIdentityInitialization() {
			const { tenant, signin, ...rest } = this.$route.query;
			if (signin === 'true' && typeof tenant === 'string') {
				const loading = this.$loading({ fullscreen: true });
				httpRequest.setAxiosTenantQuery(tenant);

				this.$router.replace({ query: rest });
				await this.authUser();
				loading.close();
			}
		},

		async getLanguages(languageId: number) {
			var languageCode = '';
			if(languageId === LANGUAGE_ID.ENGLISH){
				languageCode = LANGUAGE_CODE.ENGLISH;
			}
			else if(languageId === LANGUAGE_ID.MANDARIN){
				languageCode = LANGUAGE_CODE.MANDARIN;
			}
			else if(languageId === LANGUAGE_ID.CZECH){
				languageCode = LANGUAGE_CODE.CZECH;
			}
		    await apiProvider.setLoggedInUserLanguageId(languageId);
			window.localStorage.setItem("i18nextLng", languageCode);
			const resp = await resourcesService.loadLocalizations(languageId);
			if(resp.status === 200){
				window.location.reload();
			}
		},

		async saveState() {
			try {
				await this.saveStoreState();
			} catch (error) {
				this.error({ error });
			}
		},
		async loadState() {
			try {
				await this.loadStoreState();
			} catch (error) {
				this.error({ error });
			}
		},
		clearSavedState() {
			window.localStorage.removeItem(LOCALSTORAGE_STATE_KEY);
		},
		getInternalBreadcrumbs(): MainCrumbHandler[] {
			const pages = this.$store.state.pageManager.pages || [];

			return this.crumbs.map((crumb: string, index: number) => ({
				type: RouteType.url,
				name: crumb,
				url: pages[index] && pages[index].path ? pages[index].path : undefined,
			}));
		},
		readBreadcrumbCache(): MainCrumbHandler[] {
			const cacheJson = window.sessionStorage.getItem(BREADCRUMB_CACHE_KEY);
			if (!cacheJson) {
				return [];
			}

			try {
				const parsedCache = JSON.parse(cacheJson);
				const sourceCrumbs = Array.isArray(parsedCache)
					? parsedCache
					: (parsedCache && Array.isArray(parsedCache.crumbs) ? parsedCache.crumbs : null);

				if (!sourceCrumbs) {
					window.sessionStorage.removeItem(BREADCRUMB_CACHE_KEY);
					return [];
				}

				const validCrumbs = sourceCrumbs.filter((crumb: any) => !!crumb
					&& typeof crumb.name === 'string'
					&& crumb.type === RouteType.url
					&& (!crumb.url || typeof crumb.url === 'string'));

				if (validCrumbs.length <= 1) {
					return [];
				}

				return validCrumbs;
			} catch (error) {
				window.sessionStorage.removeItem(BREADCRUMB_CACHE_KEY);
				return [];
			}
		},
		updateBreadcrumbCache() {
			if (this.isExternal) {
				window.sessionStorage.removeItem(BREADCRUMB_CACHE_KEY);
				return;
			}

			const internalBreadcrumbs = this.getInternalBreadcrumbs().filter((crumb: MainCrumbHandler) => !!crumb.name);
			if (internalBreadcrumbs.length <= 1) {
				return;
			}

			window.sessionStorage.setItem(BREADCRUMB_CACHE_KEY, JSON.stringify(internalBreadcrumbs));
		},
		restoreBreadcrumbsFromCache() {
			if (this.isExternal) {
				this.fallbackBreadcrumbs = [];
				return;
			}

			const cache = this.readBreadcrumbCache();
			this.fallbackBreadcrumbs = Array.isArray(cache)
				? cache
				: [];
		},
		breadcrumbClicked(crumbIndex: number | null, crumb?: MainCrumbHandler) {
			const { pages } = this.$store.state.pageManager;

			if (crumb && crumb.url && crumb.type === RouteType.url && pages.length <= 1) {
				this.$router.replace(crumb.url);
				return;
			}

			if (crumb && crumb.url && crumb.type === RouteType.external) {
				this.$router.replace(crumb.url);
				const indexToPath = this.computedBreadcrumbs.findIndex((c: MainCrumbHandler) => c.url === crumb.url);
				const goCount = indexToPath === -1 ? this.computedBreadcrumbs.length : this.computedBreadcrumbs.length - indexToPath - 1;
				this.$router.go(-goCount);
			}
			switch (crumbIndex) {
				case null:
					// TODO: Toto asi nevyriesime - historia sa neda vymazat :(
					this.$router.replace({ name: 'home' });
					break;
				case pages.length - 1:
					break;
				default:
					this.$router.go(-pages.length + crumbIndex + 1);
			}
		},

		async externalFrameChecker(to: Route, from: Route, next: (path?: any) => any) {
			const elm = document.getElementById('external-module');
			if (elm && this.externalOpener?.host !== null) {
				await new Promise((resolve) => {
					const targetWindow = (elm as any).contentWindow;
					if (!targetWindow) {
						resolve(true);
						return;
					}
					targetWindow.postMessage('routeChange', this.externalOpener!.host);
					window.addEventListener(
						'message',
						function _listener(event) {
							if (event.data === 'allow' || event.data === 'deny') {
								window.removeEventListener('message', _listener);
							}
							if (event.data === 'allow') {
								resolve(true);
							}
						},
						false,
					);
				});
			}

			next();
		},

		refreshPageTitle() {
			const crumb = this.computedBreadcrumbs[this.computedBreadcrumbs.length - 1];
			document.title = crumb ? crumb.name : this.dmsAppName;
			this.isWorkshopVisible = crumb === undefined ? true : false;			
		},

		keyboardShortcutsHandler(shortcut: KeyboardEvent) {
			if (this.loading) {
				shortcut.preventDefault();
				return;
			}
			if (this.isAuth && shortcut.altKey) {
				if (shortcut.key === 'o') {
					this.openZakazkaListShortcutHandler();
				} else if (shortcut.key === 'z') {
					this.openZakazkaListShortcutHandler(true);
				} else if (shortcut.key === 'l') {
					this.logoutShortcutHandler();
				} else if (shortcut.key === 'n') {
					this.openNDSkladistShortcutHandler();
				} else if (shortcut.key === 'p') {
					this.$refs.createModal && (this.$refs.createModal as any).createClickFun();
				}
			}
			if (this.isAuth && shortcut.key === 'F5') {
				shortcut.preventDefault();
				if (shortcut.ctrlKey) {
					this.clearSavedState();
				} else {
					this.saveState();
				}
				window.location.reload();
			}
		},

		async openZakazkaListShortcutHandler(checkFilters = false) {
			if (this.currentPage.name === listName(Zakazka.name)) {
				// TODO: ZJ
				// this.setZakazkaCheckboxFilters(checkFilters);
			} else if (!this.currentPage || this.currentPage.name !== listName(Zakazka.name)) {
				await this.clearPages();
				openList(Zakazka.name, { checkFilters });
			}
		},

		async logoutExternal() {
			window.localStorage.removeItem('EXTERNAL_MODULE_DATA');
		},

		async logoutShortcutHandler() {
			if (this.$store.state.ssoState === SSOState.Auth) {
				await this.SSOLogout();
			} else {
				await this.logoutUser();
			}

			this.logoutExternal();
		},

		async openNDSkladistShortcutHandler() {
			if (!this.currentPage || this.currentPage.name !== listName(NdSklad.name)) {
				await this.clearPages();
				openList(NdSklad.name);
			}
		},
		openPlanovaciModulUrl() {
			const url = this.getDmsSysValue('DMSC_url', null);
			window.open(`${url}/?tenant=${this.tenantName}`, '_blank');
		},
		async openDms3ModulUrl() {
			await this.$store.dispatch(AUTH_AUTOLOGIN);
			const url = this.getDmsSysValue('DMS3_url', null);
			window.open(`${url}/?dms3=&autologon=${this.dms3Hash}&tenant=${this.tenantName}`, '_blank');
		},
		openDMSHelpUrl() {
			window.open(this.getDmsSysValue('DMShelp_url', null) as string, '_blank');
		},
	},
});
